import { signInWithCustomToken, sendPasswordResetEmail } from 'firebase/auth';

import type { ISelectedPlan } from 'AppRoutes/context/SubscriptionContext';
import { auth } from 'services/firebase/client';

const CLOUD_FUNCTIONS_BASE =
  'https://us-central1-clube-42-3baa5.cloudfunctions.net';

export type CreateSubscriptionAccountPayload = {
  email: string;
  fullName: string;
  cpf: string;
  phoneNumber: string;
  selectedPlan: ISelectedPlan;
};

export type CreateSubscriptionAccountErrorCode =
  | 'email_exists'
  | 'invalid_email'
  | 'invalid_name'
  | 'invalid_cpf'
  | 'invalid_phone'
  | 'missing_plan'
  | 'internal_error';

export class CreateSubscriptionAccountError extends Error {
  code: CreateSubscriptionAccountErrorCode;

  constructor(message: string, code: CreateSubscriptionAccountErrorCode) {
    super(message);
    this.name = 'CreateSubscriptionAccountError';
    this.code = code;
  }
}

type CreateAccountResponse = {
  token?: string;
  uid?: string;
  error?: string;
  code?: CreateSubscriptionAccountErrorCode;
};

export const createSubscriptionAccount = async (
  payload: CreateSubscriptionAccountPayload,
): Promise<{ uid: string }> => {
  const response = await fetch(
    `${CLOUD_FUNCTIONS_BASE}/createSubscriptionAccount`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    },
  );

  const result = (await response.json()) as CreateAccountResponse;

  if (!response.ok || !result.token || !result.uid) {
    throw new CreateSubscriptionAccountError(
      result.error || 'Erro ao criar conta. Tente novamente.',
      result.code || 'internal_error',
    );
  }

  await signInWithCustomToken(auth, result.token);

  try {
    await sendPasswordResetEmail(auth, payload.email.trim().toLowerCase());
  } catch (error) {
    console.error('Falha ao enviar e-mail de definição de senha:', error);
  }

  return { uid: result.uid };
};
